
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import _Link from 'next/link'
import { Heading as _Heading } from '@/components/Heading'
import { DocumentationLayout as _Layout } from '@/layouts/DocumentationLayout'
import { ContentsLayout as _Default } from '@/layouts/ContentsLayout'
import { Heading } from '@/components/Heading'
import { TipGood, TipBad } from '@/components/Tip'
import { CodeSample } from '@/components/CodeSample'
const Layout = _Layout;
const meta = {
  "id": "attributes",
  "title": "Attributes",
  "sidebar_label": "Attributes(Custom Field)"
};
const slug = 'attributes';
const tableOfContents = [{
  "title": "Creating Attributes Field",
  "slug": "creating-attributes-field",
  "children": [{
    "title": "Text Attribute Field",
    "slug": "text-attribute-field",
    "children": []
  }, {
    "title": "Pre-defined Values",
    "slug": "pre-defined-values",
    "children": []
  }, {
    "title": "Attribute Values Customisations",
    "slug": "attribute-values-customisations",
    "children": []
  }]
}];

const layoutProps = {
  Layout,
meta,
slug,
tableOfContents
};
const MDXLayout = _Default
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">







    <p><a parentName="p" {...{
        "href": "https://developer.tradly.app/#86de8720-6687-42de-b337-6d89f54f030d"
      }}>{`API REFERENCE`}</a></p>
    <_Heading level={2} id={"creating-attributes-field"} nextElement={{
      "type": "paragraph"
    }}>Creating Attributes Field</_Heading>
    <p>{`Attributes are additional fields you want to collect from the users. It can be used in Accounts Level, Listings level. There are 9 types of attributes you can create on top of the existing fields. `}</p>
    <p>{`The attribute fields you create can be used for collecting additional information in structured, showing as a filter in catalgoue page, etc. or using for advanced business logic in behind(Example: Storing JSON data and passing to server or Post API calls to other systems). `}</p>
    <p>{`Note:`}</p>
    <ul {...{
      "role": "list"
    }}>
      <li parentName="ul">{`You cannot change the attribute type once it is created. You can deactivate or create a new one to replace. `}</li>
      <li parentName="ul">{`When you configure an attribute for 4th level , the attribute is only available for 4th level and not to its parent level categories. You need to select/add the parent categories and child categories wherever it’s applicable. `}</li>
    </ul>
    <_Heading level={3} id={"text-attribute-field"} nextElement={{
      "type": "paragraph"
    }}>Text Attribute Field</_Heading>
    <p>{`Go to Listings > Attributes > Add Attribute `}</p>
 <img class="w-full  h-82 object-cover rounded-lg shadow-lg" alt="Attributes Creation" src="/img/attributes1.png" />
 <img class="w-full  h-82 object-cover rounded-lg shadow-lg" alt="Attributes Creation" src="/img/creating-attributes.png" />
Here we are creating an additional field for a fashion platform where it's possible to collect 'material' of the apparel/clothing. 
 <img class="w-full  h-82 object-cover rounded-lg shadow-lg" alt="Attributes Creatio" src="/img/attributes2.png" />
Apart from the basic title and tooltip, you can configure these optional items. 
    <ol {...{
      "role": "list"
    }}>
      <li parentName="ol">{`OPTIONAL: When you activate this, the field is not mandatory input by users. `}</li>
      <li parentName="ol">{`PRIVATE:  When you activate this, the field will be available in listing creation. The field value will not be available for end users. Only platform owners can see this. For example: A Private details like Phone number or something other confidential information only meant for Platform owners. `}</li>
      <li parentName="ol">{`HIDDEN FIELD:`}</li>
      <li parentName="ol">{`SHOW IN FILTER: Once you activate this. When a user is browsing the catalogue page, they can use this field to filter the items further. Example: A phone number custom field or short description may not be available in FILTER screen. `}</li>
      <li parentName="ol">{`STATUS: A platform owner may want to deactivate a custom field. He can do so by de-activating. Hence you can still have the data as a backup. Or if the fields are used in temporary form. `}</li>
    </ol>
    <_Heading level={3} id={"pre-defined-values"} nextElement={{
      "type": "paragraph"
    }}>Pre-defined Values</_Heading>
    <p>{`There are cases where you want to add pre-defined values to be selected by Listing creators. `}</p>
    <p>{`Example: `}</p>
    <ul {...{
      "role": "list"
    }}>
      <li parentName="ul">{`Age `}</li>
      <li parentName="ul">{`Color Code `}</li>
      <li parentName="ul">{`County, Region `}</li>
    </ul>
    <p>{`In the below example, let’s create a multi selection pre-defined field. Creating “Ocassion” `}</p>
 <img class="w-full  h-82 object-cover rounded-lg shadow-lg" alt="Multi Select Creation" src="/img/multi-select1.png" />
    <p>{`In the ‘Ocassion’ field, let’s add the value as well.  `}</p>
 <img class="w-full  h-82 object-cover rounded-lg shadow-lg" alt="Multi Select Creation" src="/img/multi-select0.png" />
    <p>{`Here is the end result on how it can be used in creating listings.`}</p>
 <img class="w-full  h-82 object-cover rounded-lg shadow-lg" alt="Multi Select Creation" src="/img/multi-select2.png" />
    <_Heading level={3} id={"attribute-values-customisations"} nextElement={{
      "type": "list",
      "ordered": false,
      "start": null,
      "spread": false
    }}>Attribute Values Customisations</_Heading>
    <ul {...{
      "role": "list"
    }}>
      <li parentName="ul">{`There are cases to translate the pre-defined values if you have multiple langauges. `}</li>
      <li parentName="ul">{`You may want to re-arrange the order of the values. Hence the end-users who create listings/accounts would see in the order. `}</li>
      <li parentName="ul">{`Or When you add additional values after few days of creating initially. And then want to sort alphabetically. You can! `}</li>
    </ul>
 <img class="w-full  h-82 object-cover rounded-lg shadow-lg" alt="Attribuet Values" src="/img/attribute-values4.png" />



    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
MDXContent.layoutProps = layoutProps
